import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionVersionService } from '../../services/configuracionversion.service';
import { TemaVerificarService } from '../../services/temaverificar.service';
import { Theme } from 'src/app/theme/theme';

@Component({
  selector: 'globalfooter',
  templateUrl: './globalfooter.component.html',
  styleUrls: ['./globalfooter.component.scss']
})
export class GlobalfooterComponent implements OnInit{
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public configuracionVersionService: ConfiguracionVersionService,
    public temaVerificarService: TemaVerificarService) {}

  ngOnInit() {
  }
  TemaActivoSura(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.sura;
  }
  TemaActivoAquaShield(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.aquashield;
  }
  TemaActivoCobelen(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.cobelen;
  }
  TemaActivoGlobal(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.global;
  }

}